
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-tv-line',
      title: 'アナウンサー・司会',
      description: 'ラジオパーソナリティ、リポーター、イベントMCなど、様々な場面で司会を担当いたします。',
      image: 'https://public.readdy.ai/ai/img_res/801026fd661754392ce6353326adf797.jpg',
      features: [
        'ラジオパーソナリティ',
        'リポーター',
        'イベントMC',
        'メインステージMC',
        '社交ダンスパーティーMC',
        '結婚式の司会'
      ]
    },
    {
      icon: 'ri-mic-line',
      title: 'ナレーション',
      description: 'テレビCM、企業プロモーション映像など、幅広いジャンルのナレーションを承ります。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20voice%20actress%20in%20modern%20recording%20studio%20with%20professional%20microphone%20and%20soundproof%20booth%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20background%2C%20focused%20expression%20while%20narrating%2C%20high%20quality%20photography%20style&width=400&height=300&seq=narration-service&orientation=landscape',
      features: [
        'テレビCMナレーション',
        '企業プロモーション映像',
        'イベント影アナウンス',
        '発表会アナウンス',
        'ドキュメンタリー'
      ]
    },
    {
      icon: 'ri-music-line',
      title: '舞台',
      description: '舞台作品制作事業「ラウドヒル計画」での豊富な舞台経験を活かした表現活動を行います。',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20female%20performer%20on%20theatrical%20stage%20with%20dramatic%20lighting%2C%20beautiful%20costume%2C%20expressive%20pose%20during%20musical%20or%20drama%20performance%2C%20warm%20stage%20lights%2C%20clean%20minimalist%20background%2C%20artistic%20and%20professional%20atmosphere&width=400&height=300&seq=stage-performance-service&orientation=landscape',
      features: [
        'ミュージカル出演',
        '演劇作品出演',
        'ダンス出演'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">サービス内容</h2>
          <div className="w-24 h-1 bg-pink-200 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-48 bg-gradient-to-br from-orange-400 to-red-500">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-center w-16 h-16 bg-pink-100 rounded-full mx-auto mb-4">
                  <i className={`${service.icon} text-2xl text-pink-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-center mb-4">{service.title}</h3>
                <p className="text-gray-600 text-center mb-6">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}